import { Conversation } from "./conversation.model";
import { MessageID } from "./message.model";


export class SearchTextMsgResult {
    public messageId: MessageID ;
    public historyIndex: number;

    public constructor(msgId: MessageID, historyIndex: number) {
        this.messageId = msgId;
        this.historyIndex = historyIndex;
    }
}

export class SearchTextResult {

    public conversation: Conversation;
    public room: any = null;
    public contact: any = null;
    public totalCount: number = 0;
    public convRes: SearchTextMsgResult[] = [];
    public otherJid: string;

    constructor(convId: string) {
        this.otherJid = convId;
    }

    public addMsgItem(msgItem: SearchTextMsgResult): void {
        this.convRes.push(msgItem);
    }

    public isRoom(): boolean {
        if (this.conversation) { return (this.conversation.bubble !== null); }
        return this.room !== null;
    }
}

export class SearchTextConvResults {

    private _searchedText: string = null;
    public normalizedSearchText: string = null;
    public results: SearchTextResult[] = [];
    public totalCount: number = 0;
    public currentMessageId: MessageID | null = null;
    public isSearching = false;

    public get searchedText() { return this._searchedText; }
    public set searchedText(searchText: string) {
        this._searchedText = searchText;
        if (!searchText) { this.normalizedSearchText = null; }
        else { this.normalizedSearchText = searchText.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    }

    public clearAll(): void {
        this.searchedText = null;
        this.totalCount = 0;
        this.currentMessageId = null;
        this.results.splice(0, this.results.length);
    }
}
